import { render, staticRenderFns } from "./ksTab.vue?vue&type=template&id=029bab12&scoped=true"
import script from "./ksTab.vue?vue&type=script&lang=js"
export * from "./ksTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "029bab12",
  null
  
)

export default component.exports